export const IRN =
  "a97a16b37a69efe3345344668b628193765816d76317f-51d04f1608d91fd0a20";
export const ACK_NO = "122318824516553";
export const ACK_DATE = "1-Nov-23";
export const NAME = "SION FINANCE & LEASING PVT LTD";
export const PLOT_NO = "112 SION KOLIWADA ROAD";
export const AREA = "SION";
export const AREA_CODE = "27";
export const CITY = "BOMBAY";
export const PIN_CODE = "400022";
export const STATE = "Maharashtra";
export const GST = "27AAACS9380E1Z7";
export const EMAIL = "siongarage@gmail.com";
export const SHIP_TO = "Consignee (Ship to)";
export const BILL_TO = "Buyer (Bill to)";
